import React from 'react';
import PropTypes from 'prop-types';
import oneLine from 'common-tags/lib/oneLine';
import suitcss from '../../../helpers/suitcss';

const componentName = 'Switch';
function Switch(props) {
  const { isActive, onChange, switchLabel } = props;

  return (
    <div className={suitcss({
      componentName,
    })}
    >
      <div className={suitcss({
        componentName,
        descendantName: 'badge',
      })}
      >
        <label className={suitcss({
          componentName,
          descendantName: 'switch',
        })}
        >
          <input
            type="checkbox"
            onChange={onChange}
            checked={isActive}
          />
          <span className="slider round" />
        </label>
        <div
          className={suitcss({
            componentName,
            descendantName: 'text',
          })}
          dangerouslySetInnerHTML={{
            __html: oneLine`${switchLabel}`,
          }}
        />
      </div>
    </div>
  );
}

Switch.propTypes = {
  isActive: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  switchLabel: PropTypes.string,
};

export default Switch;
